import React, { useEffect, useState } from "react"
import {createTheme, ThemeProvider} from "@mui/material/styles";
import EbookletThemeProvider from './src/components/theme.js'
import { AuthProvider } from './src/components/auth.js'

import '@material/web/all.js';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

import "firebase/app"
import "firebase/analytics"
import "firebase/auth";

const muiTheme = createTheme({
    typography: {
        fontFamily: ['Poppins', 'serif'].join(','),
    }
})

export const wrapRootElement = ({ element }) => {
    return (
        <AuthProvider>
            <EbookletThemeProvider>
                <ThemeProvider theme={muiTheme}>
                    {element}
                </ThemeProvider>
            </EbookletThemeProvider>
        </AuthProvider>
    )
}
